import { render } from "./PlayerProfile.vue?vue&type=template&id=0af2a1d2"
import script from "./PlayerProfile.vue?vue&type=script&lang=js"
export * from "./PlayerProfile.vue?vue&type=script&lang=js"

import "./PlayerProfile.vue?vue&type=style&index=0&id=0af2a1d2&lang=css"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__